import { getLogger } from '../../diagnostics/logger';
import moment from 'moment';
import { Action, ActionMeta } from '../../actions';
import {
  LOAD_PROVISIONING_EXCLUDED_DAYS_FAILURE,
  LOAD_PROVISIONING_EXCLUDED_DAYS_PENDING,
  LOAD_PROVISIONING_EXCLUDED_DAYS_SUCCESS,
} from '../../actions/actionTypes';
import { SimManagementError } from '../../models/Errors';
import { initialAppState } from '../../models/state/appState';
import { TariffsStateCacheTimeout } from '../../models/state/simProvision/cacheTimeouts';
import { ExcludedProvisioningDaysState } from '../../models/state/simProvision/simProvisionState';
const log = getLogger('simManagement.reducers.excludedProvisioningDaysReducer');

export default function excludedProvisioningDaysReducer(
  state: ExcludedProvisioningDaysState = initialAppState.simProvisionState.excludedProvisioningDays,
  action: any,
): ExcludedProvisioningDaysState {
  switch (action.type) {
    case LOAD_PROVISIONING_EXCLUDED_DAYS_PENDING: {
      const typedAction = action as Action<number[]>;
      const { payload } = typedAction;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const newState: ExcludedProvisioningDaysState = {
        commandDefinitionIds: payload.join(','),
        isLoading: true,
        items: [],
      };

      return newState;
    }
    case LOAD_PROVISIONING_EXCLUDED_DAYS_FAILURE: {
      const typedAction = action as Action<SimManagementError>;
      const { payload } = typedAction;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const changedState: Partial<ExcludedProvisioningDaysState> = {
        error: payload,
        isLoading: false,
        items: [],
      };

      const newState = Object.assign({}, state, changedState);
      return newState;
    }
    case LOAD_PROVISIONING_EXCLUDED_DAYS_SUCCESS: {
      const typedAction = action as ActionMeta<string[], number[]>;
      const { meta, payload } = typedAction;

      if (!payload) {
        log.warn('No payload');
        return state;
      }

      if (!meta) {
        log.warn('No meta');
        return state;
      }

      const now = new Date();
      const changedState: Partial<ExcludedProvisioningDaysState> = {
        expiresOn: moment(now).add(TariffsStateCacheTimeout, 'seconds').toDate(),
        commandDefinitionIds: meta.join(','),
        items: [...payload],
        isLoading: false,
        lastLoadedOn: now,
      };

      const newState = Object.assign({}, state, changedState);
      return newState;
    }
    default:
      return state;
  }
}
